import * as React from 'react';
import * as Server from "./Server.js"
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import './LiveControls.css';
import Box from '@mui/material/Box'
import {label} from './Dictionary.js';
import {theme_info} from './theme.js'
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from '@mui/material/ButtonGroup';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import LiveStatus from './LiveStatus.js'
import Snackbar from '@mui/material/Snackbar';

let default_guest_name = "";

function Templates({set_battery_level_fn}) {

    const [templates, setTemplates] = React.useState([]);
    const [openSnack, setOpenSnack] = React.useState(false);
    const [snackKey, setSnackKey] = React.useState(1);
    const [isLoading, setLoading] = React.useState(false); 
    const [isWakeDialogOpen, setWakeDialogOpen] = React.useState(false);
    const searchParams = new URLSearchParams(document.location.search);

    let device_id = searchParams.get("device_id");
    function updateTemplates()
    {
        Server.GetDeviceDetails(device_id)
        .then((res) => {
           set_battery_level_fn(res.data.battery_level, res.data.status)
           // console.log(res.data.queue)
           setTemplates(theme_info("templates"))
        })
        .catch((err) => setTemplates([]));        
    }

    function onAddClicked(iTemplate, queue) 
    {
   
        let device_id = searchParams.get("device_id");
        if (!queue) {
            Server.GetDeviceDetails(device_id)
            .then((config_res) => {
                
                if (config_res.data.status == "Active") {
                    setLoading(true)
                    let elem = document.getElementById("name")
                    Server.AddGreeting(device_id, elem.value, iTemplate, queue).then((res)=>{
                        Server.AwaitImageChange(device_id, config_res.data.current_image_url).then((res)=>{
                            setLoading(false)
                            if (res == "Sleeping")
                                setWakeDialogOpen(true)
                        })
                    })
                } else
                    setWakeDialogOpen(true)

            }).catch((err)=>{
                setLoading(false)
            });     
        } else {
            let elem = document.getElementById("name")
            Server.AddGreeting(device_id, elem.value, iTemplate, queue)
            setSnackKey(new Date().getTime())
            setOpenSnack(true)
        }
    }

    React.useEffect(() => {
       // window.addEventListener("focus", function(){
       //     updateTemplates();
       // })        
        updateTemplates();
    }, []);

    let list_images = []
    for (let i=0; i<templates.length; i++) {
        let url = templates[i].thumb_url
        list_images.push (
            <ImageListItem key={url}>
                
                <img 
                srcSet={`${url}`}
                src={`${url}`}
                // alt={item.title}
                loading="lazy"
                onClick={()=>{onAddClicked(i, false)}}
                />

                <ImageListItemBar
                actionIcon={
                    <ButtonGroup>
                <IconButton
                    sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                    onClick={() => {onAddClicked(i, true)}}
                >
                <AddIcon />
                </IconButton>
                </ButtonGroup>
                }
                />
                </ImageListItem>
        )
    }

    return (
        <>
        <LiveStatus isLoading={isLoading} isNeedsWake={isWakeDialogOpen} onWakeDialogClick={()=>{setWakeDialogOpen(false)}}></LiveStatus>
        { list_images.length==0 ? (
         <>
          </>
        ) : (
        <>
          <Stack spacing={1}>
      <FormControl fullWidth>
        <TextField
                autoFocus
               // required
                margin="dense"
                id="name"
                name="name"
                label={label("ID_EnterAGuestName")}
                type="text"
                defaultValue={default_guest_name}
                fullWidth
                variant="standard"
                onChange={(event)=>{default_guest_name=event.target.value}}
            />
            </FormControl> 
            <FormControl fullWidth>
      </FormControl> 
        <ImageList cols={Math.floor(document.documentElement.clientWidth/190)} >
            {list_images}
        </ImageList>
        <Box sx={{height:`140px`}}/>

        </Stack>
        </>
      )}
     <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        message={label("ID_AddedToPlaylist")}
        key={snackKey}
        onClose={() => {setOpenSnack(false)}}
        />     
        </>
    );
}

export default Templates;

